import { applyMiddleware, createStore } from "redux"
import reducer from "./reducer"
import thunk from "redux-thunk"
import { composeWithDevTools } from "redux-devtools-extension"
import { AppState } from "../global"

const middlewares = [thunk]

const middlewareEnhancer = applyMiddleware(...middlewares)
const composedEnhancer = composeWithDevTools(middlewareEnhancer)
export default function configureStore(initialState: AppState) {
  const store = createStore(
    // @ts-ignore

    // @ts-ignore
    reducer,
    initialState,
    composedEnhancer
  )
  return store
}
